import React, { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router';
import { BrowserRouter, Link, NavLink, } from 'react-router-dom';
import NotFoundPage from './pages/NotFoundPage';
import { useState } from 'react';
import { BrowserView, MobileView, isBrowser, isDesktop, isMobile, isTablet } from 'react-device-detect';
import HomePage from './pages/HomePage';
import ProfilePage from './pages/ProfilePage';
import MetaTags from './components/MetaTags';
import WhatIsThisPage from './pages/WhatIsThisPage';
import ArtGallery from './pages/ArtGallery';
import { useDispatch, useSelector } from 'react-redux';
import { getBot, getBotForumStat, getFilenames, getFilenamesIuiu, getUserForumStat, getUsers, getCertificateList, getBlindboxList, getMCQList } from './actions/allDataActions';
import Iuiu from './pages/Iuiu';
import SecretCodePage from './pages/SecretCodePage';
import SecurityCheckPage from './pages/SecurityCheckPage';
import Certificate from './pages/Certificate';
import Blindbox from './pages/Blindbox';
import AudioPlayer from './pages/AudioPlayer';
import IuiuNavigation from './pages/IuiuNavigation';
import UserMiniProfile from './components/UserMiniProfile';
import MultipleChoiceQuestionPage from './pages/MultipleChoiceQuestionPage';





function App() {
  // const [user, setUser] = useState({})
  // const [userForumStat, setUserForumStat] = useState({})
  // const [bot, setBot] = useState({})
  // const [botForumStat, setBotForumStat] = useState({})
  // const [filenames, setFilenames] = useState({})
  // let user = {}
  // let userForumStat = {}
  // let bot = {}
  // let botForumStat = {}
  // let filenames = []
  // const [data, setData] = useState({})
  // const fetchData = async() => {
  //   if(process.env.REACT_APP_CDN_MODE==="local" && localStorage.getItem("data") === null){
  //     user = `${process.env.REACT_APP_STATIC_CDN}/json/user.json`
  //     userForumStat = `${process.env.REACT_APP_STATIC_CDN}/json/userForumStat.json`
  //     bot = `${process.env.REACT_APP_STATIC_CDN}/json/bot.json`
  //     botForumStat = `${process.env.REACT_APP_STATIC_CDN}/json/botForumStat.json`
  //     filenames =`${process.env.REACT_APP_STATIC_CDN}/json/filenames.json`
  //   }else{
  //     const userData = await fetch(`${process.env.REACT_APP_STATIC_CDN}/json/user.json`,{
  //       method: 'GET',
  //       mode: 'cors',
  //     }).then(response => response.json())
  //     .then(data => {
  //       console.log(data)
  //       return data
  //     })
  //     user = userData
  
  //     const userForumStatData = await fetch(`${process.env.REACT_APP_STATIC_CDN}/json/userForumStat.json`,{
  //       method: 'GET',
  //       mode: 'cors',
  //     }).then(response => response.json())
  //     .then(data => {
  //       console.log(data)
  //       return data
  //     })
  //     userForumStat = userForumStatData
  
  //     const botData = await fetch(`${process.env.REACT_APP_STATIC_CDN}/json/bot.json`,{
  //       method: 'GET',
  //       mode: 'cors',
  //     }).then(response => response.json())
  //     .then(data => {
  //       console.log(data)
  //       return data
  //     })
  //     bot = botData
  
  //     const botForumStatData = await fetch(`${process.env.REACT_APP_STATIC_CDN}/json/botForumStat.json`,{
  //       method: 'GET',
  //       mode: 'cors',
  //     }).then(response => response.json())
  //     .then(data => {
  //       console.log(data)
  //       return data
  //     })
  //     botForumStat = botForumStatData
  
  //     const filenamesData = await fetch(`${process.env.REACT_APP_STATIC_CDN}/json/filenames.json`,{
  //       method: 'GET',
  //       mode: 'cors',
  //     }).then(response => response.json())
  //     .then(data => {
  //       console.log(data)
  //       return data
  //     })
  //     filenames = filenamesData


  //     localStorage.setItem("data", JSON.stringify({user, userForumStat, bot, botForumStat, filenames}))


  //     // Retrieve data
  //     setData(JSON.parse(JSON.stringify(localStorage.getItem("data"))));
  //   }
  // }

  const dispatch = useDispatch()

  const userData = useSelector(state => state.userData);
  const {loading: loadingUser, error: errorUser, user} = userData;

  const userForumStatData = useSelector(state => state.userForumStatData);
  const {loading: loadingUserForumStat, error: errorUserForumStat, userForumStat} = userForumStatData;

  const botData = useSelector(state => state.botData);
  const {loading: loadingBot, error: errorBot, bot} = botData;

  const botForumStatData = useSelector(state => state.botForumStatData);
  const {loading: loadingBotForumStat, error: errorBotForumStat, botForumStat} = botForumStatData;

  const filenamesData = useSelector(state => state.filenamesData);
  const {loading: loadingFilenames, error: errorFilenames, filenames} = filenamesData;

  const filenamesIuiuData = useSelector(state => state.filenamesIuiuData);
  const {loading: loadingFilenamesIuiu, error: errorFilenamesIuiu, filenamesIuiu} = filenamesIuiuData;

  const certificateListData = useSelector(state => state.certificateListData);
  const {loading: loadingCertificateList, error: errorCertificateList, certificateList} = certificateListData;

  const blindboxListData = useSelector(state => state.blindboxListData);
  const {loading: loadingBlindboxList, error: errorBlindboxList, blindboxList} = blindboxListData;

  const MCQListData = useSelector(state => state.MCQListData);
  const {loading: loadingMCQList, error: errorMCQList, MCQList} = MCQListData;

  // const MCQList = [
  //   {
  //   "Id": 1,
  //   "Autore": "Leonardo da Vinci",
  //   "Opera": "Ultima Cena",
  //   "Data": "Ante 1489",
  //   "Caratteristiche chiave": "Soggetto sacro. Sperimentazione tecnica fallimentare sulla parete del refettorio. Fu un progetto per Ludovico il Moro ",
  //   "Image": "https://drive.google.com/file/d/1GOVVZLSCA7u1imJYbi8Hueae2hHEEchg/view?usp=drive_link"
  //   },
  //   {
  //     "Id": 2,
  //     "Autore": "Leonardo da Vinci",
  //     "Opera": "Ritratto di Cecilia Gallerani (detta Dama con l’ermellino)",
  //     "Data": "non specificata ",
  //     "Caratteristiche chiave": "La donna e l’animale sono ritratti di tre quarti, in posa dinamica, su fondo scuro di radice fiamminga",
  //     "Image": "https://drive.google.com/file/d/13dIUn2mfTu0qmshmWElQZTfVr0fxT4pH/view?usp=drive_link"
  //   },
  //   {
  //     "Id": 3,
  //     "Autore": "Leonardo da Vinci",
  //     "Opera": "Vergine delle rocce (Versione Louvre)",
  //     "Data": "ca. 1483-1485 ",
  //     "Caratteristiche chiave": "Ambientazione rocciosa, atmosfera umida e nebbiosa tipica del paesaggio leonardesco; composizione piramidale; forte uso di chiaroscuro e profondità atmosferica; grande impatto innovativo a Milano.",
  //     "Image": "https://drive.google.com/file/d/1Q_RFN3GANfsN4M78gI7OI7oHyji0fFhL/view?usp=drive_link"
  //   },
  //   {
  //     "Id": 4,
  //     "Autore": "Leonardo da Vinci",
  //     "Opera": "Vergine delle rocce (Versione Londra)",
  //     "Caratteristiche chiave": "Ambientazione rocciosa, atmosfera umida e nebbiosa tipica del paesaggio leonardesco; composizione piramidale; forte uso di chiaroscuro e profondità atmosferica; grande impatto innovativo a Milano.",
  //     "Data": "1494-1508 ",
  //     "Image": "https://drive.google.com/file/d/17jX3G4YFc1xuYEtCxANCFB2NSvlqo2B_/view?usp=drive_link"
  //   }
  // ]


  const [menu, setMenu] = useState(false);
  const [musicPlayer, setMusicPlayer] = useState({height: "0", width: "500"})
  const [activeTab, setActiveTab] = useState("")

  const getYouTubeLinkId = (url) =>{
    if(url){
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }else{
      return ""
    }
    
}
 
  // let audioBeep = new Audio("/assets/beep.mp3");
  // let audioMenuSelectionClick = new Audio("/assets/MenuSelectionClick.mp3");

  const getAllData = () => {
    dispatch(getUsers());
    dispatch(getUserForumStat());
    dispatch(getBot());
    dispatch(getBotForumStat());
    dispatch(getFilenames());
    dispatch(getFilenamesIuiu());
    dispatch(getCertificateList());
    dispatch(getBlindboxList());
    dispatch(getMCQList())
  }
  const handleSwitchTab = (tabIndex, path) => {
    setActiveTab(tabIndex)
  }

  useEffect(()=>{
    getAllData()
  }, []);

  return (
      <BrowserRouter>
          
        {/* {filenames.map((filename, i)=>(
          <div className='stickyBookmark' style={{height: `${100*i}rem`}}>{filename.albumTitle}</div>
        ))} */}
          
        <MetaTags></MetaTags>
        <div className="grid-containter">
              <header className="row navigation-bar">
                  <div>
                    <NavLink to="/" className={({ isActive }) => (isActive ? 'brand selected' : 'brand')}>Devpresso</NavLink>
                  </div>
                {/* {
                isBrowser ? <>
                  <div>
                    <Link to={`/news`} className="">News</Link>
                  </div>
                  {user && <div>
                    <div className='col-0'><div className='clickable itemLink no-select' onClick={()=>{
                      const globalBackgroundMusicPlayer = document.querySelector(".globalBackgroundMusicPlayer");
                      if(globalBackgroundMusicPlayer.classList.contains("invisible")){
                        setMusicPlayer({height: "200", width: "500"})
                      }else{
                        setMusicPlayer({height: "0", width: "500"})
                      }
                      globalBackgroundMusicPlayer.classList.toggle("invisible");
                      
                    }}>Global background music</div>
                     <div className='globalBackgroundMusicPlayer row center invisible' style={{paddingTop: "0"}}>
                        <div className='row center'>
                          <iframe src={`https://www.youtube.com/embed/${getYouTubeLinkId(user?.[Object.keys(user)[0]]?.backgroundMusic)}?mute=0&loop=1`} type="application/x-shockwave-flash" allowscriptaccess="always" allowFullScreen={true} width={musicPlayer.height} height={musicPlayer.height} allow='autoplay'></iframe>
                        </div>
                        <div className='row center'>
                          <iframe style={{position: "relative"}} src={`https://www.youtube.com/embed/videoseries?mute=0&loop=1&list=PLyTTovvxYVsO1UZajvQlvRQSrX61Q6tT3`} type="application/x-shockwave-flash" allowscriptaccess="always" allowFullScreen={true} width={musicPlayer.height} height={musicPlayer.height}></iframe>
                        </div>
                      </div>
                    </div>
                  </div>}
                  <div>
                    <NavLink className={({ isActive }) => (isActive ? 'itemLink selected' : 'itemLink')} to={`/iuiu`}>My❤️</NavLink>
                  </div>
                  <div>
                    <NavLink className={({ isActive }) => (isActive ? 'itemLink selected' : 'itemLink')} to={`/art-gallery`}>My art gallery</NavLink>
                  </div>
                  <div>
                    <NavLink className={({ isActive }) => (isActive ? 'itemLink selected' : 'itemLink')} to={`/what-is-this`}>What is this?</NavLink>
                  </div>
                      
                  </>: 
                  isMobile &&
                      <div className='row left'>
                        <div className='interactiveText row left'  onClick={()=>
                          {
                            if(!menu){
                              setMenu(!menu);
                            }else{
                              const navigationBar = document.querySelector(".navigationBar");
                                if(navigationBar){
                                  navigationBar.classList.add("close");
                                }
                              setTimeout(()=>{
                                setMenu(!menu);
                              }, 500)
                            }
                          }
                        }><i className={menu ? `fa-solid fa-xmark` : `fa fa-bars`}></i></div>
                        {menu && (<ul className='navigationBar'>
                          <li>
                            <NavLink className={({ isActive }) => (isActive ? 'itemLink selected' : 'itemLink')} to={`/iuiu`}>My❤️</NavLink>
                          </li>
                          <li>
                            <NavLink className={({ isActive }) => (isActive ? 'itemLink selected' : 'itemLink')} to={`/art-gallery`}>My art gallery</NavLink>
                          </li>
                          <li>
                            <NavLink className={({ isActive }) => (isActive ? 'itemLink selected' : 'itemLink')} to={`/what-is-this`}>What is this?</NavLink>
                          </li>
                          <li className='s'>
                            <div className='clickable itemLink no-select' onClick={()=>{
                              const globalBackgroundMusicPlayer = document.querySelector(".globalBackgroundMusicPlayer");
                              if(globalBackgroundMusicPlayer.classList.contains("invisible")){
                                setMusicPlayer({height: "200", width: "500"})
                              }else{
                                setMusicPlayer({height: "0", width: "500"})
                              }
                              globalBackgroundMusicPlayer.classList.toggle("invisible");
                              
                            }}>Global background music</div>
                            <div className='globalBackgroundMusicPlayer row center invisible' style={{paddingTop: "0"}}>
                                <div className='row center'>
                                  <iframe src={`https://www.youtube.com/embed/${getYouTubeLinkId(user.backgroundMusic)}?mute=0&loop=1`} type="application/x-shockwave-flash" allowscriptaccess="always" allowFullScreen={true} width={musicPlayer.height} height={musicPlayer.height} allow='autoplay'></iframe>
                                </div>
                                <div className='row center'>
                                  <iframe style={{position: "relative"}} src={`https://www.youtube.com/embed/videoseries?mute=0&loop=1&list=PLyTTovvxYVsO1UZajvQlvRQSrX61Q6tT3`} type="application/x-shockwave-flash" allowscriptaccess="always" allowFullScreen={true} width={musicPlayer.height} height={musicPlayer.height}></iframe>
                                </div>
                              </div>
                          </li>
                        </ul>)
                      }
                      </div>
                  } */}
                  <div className='row left'>
                        <div className='interactiveText row left'  onClick={()=>
                          {
                            if(!menu){
                              setMenu(!menu);
                            }else{
                              const navigationBar = document.querySelector(".navigationBar");
                                if(navigationBar){
                                  navigationBar.classList.add("close");
                                }
                              setTimeout(()=>{
                                setMenu(!menu);
                              }, 500)
                            }
                          }
                        }><i className={menu ? `fa-solid fa-xmark` : `fa fa-bars`}></i></div>
                        {menu && (<ul className='navigationBar'>
                          <li>
                            <NavLink className={({ isActive }) => (isActive ? 'itemLink selected' : 'itemLink')} to={`/iuiu-navigation`}>My❤️</NavLink>
                          </li>
                          <li>
                            <NavLink className={({ isActive }) => (isActive ? 'itemLink selected' : 'itemLink')} to={`/art-gallery`}>My art gallery</NavLink>
                          </li>
                          <li>
                            <NavLink className={({ isActive }) => (isActive ? 'itemLink selected' : 'itemLink')} to={`/what-is-this`}>What is this?</NavLink>
                          </li>
                          <li className='s'>
                            <div className='clickable itemLink no-select' onClick={()=>{
                              const globalBackgroundMusicPlayer = document.querySelector(".globalBackgroundMusicPlayer");
                              if(globalBackgroundMusicPlayer.classList.contains("invisible")){
                                setMusicPlayer({height: "200", width: "500"})
                              }else{
                                setMusicPlayer({height: "0", width: "500"})
                              }
                              globalBackgroundMusicPlayer.classList.toggle("invisible");
                              
                            }}>Global background music</div>
                            <div className='globalBackgroundMusicPlayer row center invisible' style={{paddingTop: "0"}}>
                                <div className='row center'>
                                  <iframe src={`https://www.youtube.com/embed/${getYouTubeLinkId(user.backgroundMusic)}?mute=0&loop=1`} type="application/x-shockwave-flash" allowscriptaccess="always" allowFullScreen={true} width={musicPlayer.height} height={musicPlayer.height} allow='autoplay'></iframe>
                                </div>
                                <div className='row center'>
                                  <iframe style={{position: "relative"}} src={`https://www.youtube.com/embed/videoseries?mute=0&loop=1&list=PLyTTovvxYVsO1UZajvQlvRQSrX61Q6tT3`} type="application/x-shockwave-flash" allowscriptaccess="always" allowFullScreen={true} width={musicPlayer.height} height={musicPlayer.height}></iframe>
                                </div>
                              </div>
                          </li>
                        </ul>)
                      }
                      </div>
              </header>
              <main>
              <div>
              </div>
              {/* {isBrowser} */}
                <Routes>
                  {/* React Router Dom v6 syntax */}
                  <Route exact path="/" element={<HomePage user={user}></HomePage>}></Route>
                  <Route exact path="/what-is-this" element={<WhatIsThisPage></WhatIsThisPage>}></Route>
                  <Route exact path="/secret-code-prompt" element={<SecretCodePage></SecretCodePage>}></Route>

                  {/* <Route exact path="/iuiu" element={<Iuiu filenames={filenamesIuiu} user={user}></Iuiu>}></Route> */}
                  <Route
                    exact
                    path="/iuiu-navigation"
                    element={
                      <SecurityCheckPage>
                        <IuiuNavigation/>
                      </SecurityCheckPage>
                    }
                  />
                  <Route
                    exact
                    path="/iuiu"
                    element={
                      <SecurityCheckPage>
                        <Iuiu filenames={filenamesIuiu} user={user} />
                      </SecurityCheckPage>
                    }
                  />
                  <Route
                    path="/certificate/:id"
                    element={
                      <SecurityCheckPage>
                        <Certificate certificateList={certificateList} />
                      </SecurityCheckPage>
                    }
                  />
                  <Route
                    path="/blindbox/:id"
                    element={
                      <SecurityCheckPage>
                        <Blindbox blindboxList={blindboxList} />
                      </SecurityCheckPage>
                    }
                  />
                  <Route
                    path="/mcq"
                    element={
                      <SecurityCheckPage>
                        <MultipleChoiceQuestionPage importedMCQList={MCQList} MCQListMirror={MCQList && JSON.parse(JSON.stringify(MCQList))} userForumStat={userForumStat}/>
                      </SecurityCheckPage>
                    }
                  />
                  <Route
                    path="/audio/:id"
                    element={
                      <SecurityCheckPage>
                        <AudioPlayer/>
                      </SecurityCheckPage>
                    }
                  />
                  {/* <Route exact path="/signin" element={<SigninPage></SigninPage>}></Route> */}
                  {/* <Route exact path="/signup" element={<SignUpPage></SignUpPage>}></Route> */}
                  <Route path="/user/Minto" element={<ProfilePage user={user} userForumStat={userForumStat} bot={bot} filenames={filenames}></ProfilePage>}></Route>
                  <Route path="/@Minto" element={<ProfilePage user={user} userForumStat={userForumStat} bot={bot} filenames={filenames}></ProfilePage>}></Route>
                  <Route path="/Minto" element={<ProfilePage user={user} userForumStat={userForumStat} bot={bot} filenames={filenames}></ProfilePage>}></Route>
                  <Route path="/me" element={<ProfilePage user={user} userForumStat={userForumStat} bot={bot} filenames={filenames}></ProfilePage>}></Route>
                  <Route path="/@me" element={<ProfilePage user={user} userForumStat={userForumStat} bot={bot} filenames={filenames}></ProfilePage>}></Route>
                  <Route path="/user/Chowcolate" element={<ProfilePage user={user} userForumStat={userForumStat} bot={bot} filenames={filenames}></ProfilePage>}></Route>
                  <Route path="/@Chowcolate" element={<ProfilePage user={user} userForumStat={userForumStat} bot={bot} filenames={filenames}></ProfilePage>}></Route>
                  <Route path="/Chowcolate" element={<ProfilePage user={user} userForumStat={userForumStat} bot={bot} filenames={filenames}></ProfilePage>}></Route>
                  <Route path="/you" element={<ProfilePage user={user} userForumStat={userForumStat} bot={bot} filenames={filenames}></ProfilePage>}></Route>
                  <Route path="/@you" element={<ProfilePage user={user} userForumStat={userForumStat} bot={bot} filenames={filenames}></ProfilePage>}></Route>
                  <Route path="/user/MentalBot" element={<ProfilePage user={bot} userForumStat={botForumStat} filenames={filenames}></ProfilePage>}></Route>
                  <Route path="/@MentalBot" element={<ProfilePage user={bot} userForumStat={botForumStat} filenames={filenames}></ProfilePage>}></Route>
                  <Route path="/MentalBot" element={<ProfilePage user={bot} userForumStat={botForumStat} filenames={filenames}></ProfilePage>}></Route>
                  {/* <Route exact path="/forum" element={<ForumPage></ForumPage>}></Route>  */}
                  <Route path="art-gallery" element={<ArtGallery filenames={filenames} user={user}></ArtGallery>}></Route>
                  {/* <Route exact path="/mentalbot" element={<MentalBotPage></MentalBotPage>}></Route>  */}
                  {/* <Route exact path="/forum/post/:id" element={<PostDetailPage></PostDetailPage>}></Route> */}
                  {/* <Route exact path="/feedback" element={<AdminRoute><FeedbackPage></FeedbackPage></AdminRoute>}></Route>  */}
                  {/* <Route exact path="/user/list" element={<AdminRoute><UserListPage></UserListPage></AdminRoute>}></Route>  */}
                  {/* <Route exact path="/admin/stat" element={<AdminRoute><StatisticPage></StatisticPage></AdminRoute>}></Route>  */}
                  {/* <Route exact path="/forum" element={<ForumPage></ForumPage>}></Route> */}
                  {/* {currentSocket !== null && <Route exact path="/forum/post/:id" element={<PostDetailPage currentSocket={currentSocket}></PostDetailPage>}></Route>} */}
                  {/* <Route exact path="/news" element={<NewsPage></NewsPage>}></Route> */}
                  {/* <Route exact path="/chatbot" element={<MobileChatBot></MobileChatBot>}></Route> */}
                  {/* {currentSocket !== null &&<Route exact path="/notification" element={<MobileNotification currentSocket={currentSocket}></MobileNotification>}></Route>} */}
                  {/* <Route exact path="/voicerecorder" element={<VoiceRecorderComponent source="https://webrtc.github.io/samples/src/video/chrome.webm"></VoiceRecorderComponent>}></Route> Easter Eggs */}
                  {/* <Route path="/mobilePhone" element={<div className='row center top'><Keypad/></div>} />  */}
                  <Route path="*" element={<NotFoundPage/>} /> 
                  
                </Routes>
                  
                
              </main>
              <footer>
                  {isDesktop && user && user.role!=="bot" && <div className='row space'>
                       <div className='row center'>
                          <div className='row center'><div className='row'>CREATED BY</div>  
                              <UserMiniProfile user={user?.[Object.keys(user)[0]]}></UserMiniProfile>
                          </div>
                      </div>
                  </div>}
                  {(isMobile || isTablet) &&  user && user.role!=="bot" && <div className='footerNavBar'>
                        {/* <div className='navTab footer'> */}
                            <NavLink to="/" className={({ isActive }) => (isActive ? 'footerNavItem selected' : 'footerNavItem')}>
                              <div><i className='fa fa-home bold'></i></div>
                              <div>Home</div>
                            </NavLink>
                            <NavLink to="/art-gallery" className={({ isActive }) => (isActive ? 'footerNavItem selected' : 'footerNavItem')}>
                              <div><i className='fa fa-image bold'></i></div>
                              <div>Art Gallery</div>
                            </NavLink>
                            <NavLink to="/iuiu-navigation" className={({ isActive }) => (isActive ? 'footerNavItem selected' : 'footerNavItem')}>
                              <div><i className='fa fa-heart bold'></i></div>
                              <div>Iuiu</div>
                            </NavLink>
                            <NavLink to="/blindbox/daily-blindbox" className={({ isActive }) => (isActive ? 'footerNavItem selected' : 'footerNavItem')}>
                              <div><i className='fa fa-box bold'></i></div>
                              <div>Blindbox</div>
                            </NavLink>
                        {/* </div> */}
                  </div>}
              </footer>
             
          </div>
      </BrowserRouter>
    
  );
}


export default App;
